import React from 'react';
import { Avatar, Col, Dropdown, DropDownProps, Row } from 'antd';
import { H6 } from '@app/components/common/typography/H6/H6';
import { ProfileOverlay } from '../ProfileOverlay/ProfileOverlay';
import { useAppSelector } from '@app/hooks/reduxHooks';
import { useResponsive } from '@app/hooks/useResponsive';
import * as S from './ProfileDropdown.styles';
import { getProfilePhoto } from '@app/utils/utils';

interface ProfileDropdownProps {
  /** Sider usage opens upward; the header opens downward. */
  placement?: DropDownProps['placement'];
  /** Avatar only, for the collapsed 80px sider. */
  compact?: boolean;
}

export const ProfileDropdown: React.FC<ProfileDropdownProps> = ({ placement, compact }) => {
  const { isTablet } = useResponsive();

  const user = useAppSelector((state) => state.user.user);

  return user ? (
    <Dropdown overlay={<ProfileOverlay />} trigger={['click']} placement={placement}>
      <S.ProfileDropdownHeader as={Row} gutter={[10, 10]} align="middle">
        <Col>
          <Avatar src={getProfilePhoto(user.profile_picture)} alt="User" shape="circle" size={40} />
        </Col>
        {isTablet && !compact && (
          <Col>
            <H6>{user.name}</H6>
          </Col>
        )}
      </S.ProfileDropdownHeader>
    </Dropdown>
  ) : null;
};
